import React, { useContext, useState } from "react";
import {
  Col,
  Form,
  CardBody,
  FormGroup,
  Input,
  Label,
  Button,
} from "reactstrap";
import { Redirect,Link} from "react-router-dom"
import { toast } from "react-toastify";
import validator from "validator";
import Axios from "axios";
import { UserContext } from "../../context/UserContext";
const Varificationotp = () => {
  const context = useContext(UserContext);
  const [issubmited  , setSubmit] = useState(false)
  const [email, setEmail] = useState(context.user?.otpemail);
  console.log(setEmail)
  const [otp, setOtp] = useState("");
  // const [password,setPassword]=useState('')
  const logindata = {
    email: "", otp: "",
  };
  // if(context.user===null)
  // {
  //   toast.error("Seems that you have refresh Page,try again", {
  //     position: toast.POSITION.BOTTOM_LEFT,
  //   });
  // } 
  const handleFormSubmit = (e) => {
    e.preventDefault();
    verifyotp();
  };
  const verifyotp = async () => {
    if (otp === "") {
      toast.error("Otp is Empty", { position: toast.POSITION.BOTTOM_LEFT });
      return;
    } else if (!validator.isNumeric(otp)) {
      toast.error("Please Enter valid OTP", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    }
    logindata.email = email;
    logindata.otp = otp;
    await Axios.post("Login/verifyotp", { logindata })
      .then((res) => {
        if (res.data.status === "200" && res.data.msg === "true") {
          toast.success("Otp match successfully!!", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          setSubmit({ issubmited : true });
          context.setUser({ otp: res.data.status, otpemail: email })
          return res;
        } else if (res.data.status === "200" && res.data.msg === "false") {
          toast.error("Otp did not match!", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          setOtp("");
          return res;
        } else if (res.data.status === "200" && res.data.msg === "expired") {
          toast.error("Otp Expired.!", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          return res;
        } else {
          toast.error("Something went wrong", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
        }
        throw res;
      })
      .then((resJson) => { })
      .catch((error) => {
        console.log("error123", error);
      });

  };
  if (issubmited) {
		return <Redirect to="/Changepassword" />
	}
  return (
    <div>
      <div class="containers-login">
        <div class="forms-container">
          <div class="signin-signup">
            <Form onSubmit={handleFormSubmit} class="sign-in-form">
              <h2 class="title">Verify OTP</h2>
              {this?.props?.location?.state?.email}
              <CardBody>
              <FormGroup row>
                    <Label for="email" sm={3}>
                      username
                    </Label>
                    <Col sm={9}>
                      <Input
                        type="text"
                        name="emai"
                        id="emai"
                        value={email}
                        disabled={true}
                      />
                    </Col>
                  </FormGroup>
                <FormGroup row>
                  <Col >
                    <Input
                      type="text"
                      name="otp"
                      id="otp"
                      placeholder="Enter Otp Here"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </Col>
                </FormGroup>
              </CardBody>
              <Button type='submit' class="btn transparent">
                Verify
							</Button>
            </Form>
          </div>
        </div>
        <div class="panelss-container">
					<div class="panels left-panels">
						<div class="content contents " >
							<h3>Part of Eduplusnow ?</h3>
							<p>
								Welcome back to eduplusnow
          					  </p>
							<Link class="btn transparent" to="/signin"> Sign in</Link>
						</div>
						<img src="/assets/images/eduplusnow1.png" alt="eduplusnow_white" class="image" />
					</div>
				</div>
      </div>
    </div>
  );
};

export default Varificationotp;
